<div>
    <button (click)="onClickHandler()">{{
        (productExist ? 'pdf_catalog.remove_from_pdf' : 'pdf_catalog.add_to_pdf') | translate}}
    </button>
</div>

